/* eslint-disable jsx-a11y/anchor-is-valid */
import ImagesUrl from "#constants/images.js";
import { useLanguageContext } from "#contexts/languageContext.jsx";

import React, { useState } from "react";
import BreadCrumb from "./BreadCrumb";
import { useTranslation } from "react-i18next";
import { useSideBarContext } from "#contexts/sidebarContext.jsx";

import { useNavigate } from "react-router-dom";
import { WebRoutePath } from "#routes/routePath.jsx";
import useGet from "#hooks/useGet.js";
import ENDPOINTS from "#services/endPoints.js";
import QUERY_KEYS from "#services/queryKeys.js";

const Header = ({ header }) => {
  const { changeLanguage } = useLanguageContext();
  const { toggleSidebar } = useSideBarContext();
  const nav = useNavigate();
  const { t } = useTranslation();
  const { data: profileData } = useGet(
    ENDPOINTS.GET_PROFILE,
    QUERY_KEYS.GET_PROFILE_QUERY_KEY
  );
  const currentLanguage = localStorage?.getItem("language") || "en";

  const [active, setActive] = useState(false);

  const handleLanguageChange = (item) => {
    changeLanguage(item.lngValue);
    setActive(false);
  };

  return (
    <header>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="header_wrapper">
              <div className="header_logo_blk d-flex justify-content-start align-items-center">
                <button
                  className={
                    window.innerWidth <= 992 ? "btn-box" : " btn-box d-none"
                  }
                  onClick={toggleSidebar}
                >
                  <span className="btn_bar btn_width top" />
                  <span className="btn_bar" />
                  <span className="btn_bar btn_width bottom" />
                </button>
                <BreadCrumb />
              </div>
              <div className="header_navbar-wrapper d-flex justify-content-end align-items-center">
                {/* <div className="change-lng-select">
                  <button
                    onClick={() => setActive(!active)}
                    className="lang-btn"
                  >
                    {localStorage?.getItem("language") || "en"}
                    {!active ? (
                      <svg
                        width={18}
                        height={18}
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 64 64"
                        id="arrow"
                      >
                        <path
                          d="m-218.7-308.6 2-2 11.7 11.8 11.7-11.8 2 2-13.7 13.7-13.7-13.7"
                          fill="white"
                          stroke="white"
                          transform="translate(237 335)"
                        ></path>
                      </svg>
                    ) : (
                      <svg
                        width={18}
                        height={18}
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 64 64"
                        id="arrow"
                      >
                        <path
                          d="m-191.3-296.9-2 2-11.7-11.7-11.7 11.7-2-2 13.7-13.7 13.7 13.7"
                          fill="white"
                          stroke="white"
                          transform="translate(237 335)"
                        ></path>
                      </svg>
                    )}
                  </button>
                  <div
                    style={{ top: "calc(100% + -5px)", zIndex: 1 }}
                    className={`lang-list-blk ${active ? "lang-drop" : ""}`}
                  >
                    {languageDropdown?.map((item, index) => {
                      return (
                        <div key={index} className="lang-item">
                          <button
                            onClick={() => handleLanguageChange(item)}
                            className={`language-btn lang-en ${
                              item.lngValue == currentLanguage ? "active" : ""
                            }`}
                          >
                            {item.name}
                          </button>
                        </div>
                      );
                    })}
                  </div>
                </div> */}
                <div className="navbar_prof-wrapper d-flex justify-content-end align-items-center">
                  {/* <div className="header_notification-blk">
                    <button className="header_notification-btn ">
                      <svg
                        width={19}
                        height={21}
                        viewBox="0 0 19 21"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M17.572 14.5996C16.8061 13.6684 15.7575 12.3493 15.7575 11.0034V6.71804C15.7575 3.02664 12.9966 0.0229797 9.46796 0.0229797C5.93865 0.0229797 3.19946 3.02664 3.19946 6.71804V11.0034C3.19946 12.3264 2.06152 13.5765 1.3403 14.5471C0.691271 15.4186 0.178739 16.1077 0.52524 16.7961C0.829083 17.4018 1.59099 17.4792 2.22033 17.4792H5.98065C5.98196 19.4112 7.54843 20.9777 9.48043 20.9777C11.4124 20.9777 12.9802 19.4119 12.9809 17.4792H16.8291C17.2294 17.4792 18.1652 17.4792 18.4875 16.798C18.8123 16.109 18.2926 15.4757 17.572 14.5996ZM9.47977 19.6029C8.3064 19.6029 7.35418 18.6526 7.35287 17.4799H11.6067C11.6047 18.6526 10.6538 19.6029 9.47977 19.6029ZM16.8291 16.0821H2.21968C2.11927 16.0821 2.03527 16.0788 1.96636 16.0742C2.10155 15.8649 2.29974 15.5971 2.46183 15.3799C3.26115 14.3056 4.59793 12.7884 4.59793 11.0034V6.71804C4.59793 3.79642 6.71105 1.42014 9.46927 1.42014C12.2275 1.42014 14.3616 3.79707 14.3616 6.71804V11.0034C14.3616 12.8494 15.5941 14.3922 16.4938 15.4869C16.6454 15.6713 16.8265 15.8918 16.9676 16.0808C16.9256 16.0821 16.8796 16.0827 16.8304 16.0827L16.8291 16.0821Z"
                          fill="black"
                        />
                      </svg>
                    </button>
                  </div> */}
                  <div className="header_profile-blk position-relative">
                    <button
                      type="button"
                      className="header_profile-btn dropdown-toggle"
                      data-bs-toggle="dropdown"
                      data-bs-display="static"
                      aria-expanded="false"
                    >
                      <span className="header_user_profile">
                        <img
                          src={
                            profileData?.data?.image
                              ? profileData?.data?.image
                              : ImagesUrl.noProfile
                          }
                          alt="Profile"
                          ss
                        />
                      </span>
                      <span className="d-none d-sm-flex flex-column align-items-start">
                        <span>
                          {`Hi, ${profileData?.data?.firstName} ${profileData?.data?.lastName}`}
                          <span className="down-icon ms-2">
                            <img
                              src="/assets/images/icons/header-pro-arrow-icon.svg"
                              alt="down"
                            />
                          </span>
                        </span>
                        <span className="user_role text-start">
                          Agronomists
                        </span>
                      </span>
                    </button>
                    <ul className="dropdown-menu dropdown-menu-end dropdown-menu-sm-end">
                      <li>
                        <a
                          className="dropdown-item text-capitalize"
                          onClick={() => nav(WebRoutePath.PROFILE.path)}
                        >
                          <span className="dropdown_item-icon">
                            <svg
                              width={16}
                              height={18}
                              viewBox="0 0 16 18"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M8.00013 9.62499C5.35846 9.62499 3.20846 7.47499 3.20846 4.83332C3.20846 2.19166 5.35846 0.0416565 8.00013 0.0416565C10.6418 0.0416565 12.7918 2.19166 12.7918 4.83332C12.7918 7.47499 10.6418 9.62499 8.00013 9.62499ZM8.00013 1.29166C6.05013 1.29166 4.45846 2.88332 4.45846 4.83332C4.45846 6.78332 6.05013 8.37499 8.00013 8.37499C9.95013 8.37499 11.5418 6.78332 11.5418 4.83332C11.5418 2.88332 9.95013 1.29166 8.00013 1.29166ZM15.1585 17.9583C14.8168 17.9583 14.5335 17.675 14.5335 17.3333C14.5335 14.4583 11.6001 12.125 8.00013 12.125C4.40013 12.125 1.4668 14.4583 1.4668 17.3333C1.4668 17.675 1.18346 17.9583 0.841797 17.9583C0.50013 17.9583 0.216797 17.675 0.216797 17.3333C0.216797 13.775 3.70846 10.875 8.00013 10.875C12.2918 10.875 15.7835 13.775 15.7835 17.3333C15.7835 17.675 15.5001 17.9583 15.1585 17.9583Z"
                                fill="black"
                              />
                            </svg>
                          </span>
                          <span>{t("My Profile")}</span>
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item text-capitalize"
                          onClick={() => nav(WebRoutePath.CHANGE_PASSWORD.path)}
                        >
                          <span className="dropdown_item-icon">
                            <svg
                              width={20}
                              height={20}
                              viewBox="0 0 16 16"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M4 6.66658V5.33325C4 3.12659 4.66667 1.33325 8 1.33325C11.3333 1.33325 12 3.12659 12 5.33325V6.66658"
                                stroke="#10140B"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M8.00016 12.3333C8.92064 12.3333 9.66683 11.5871 9.66683 10.6667C9.66683 9.74619 8.92064 9 8.00016 9C7.07969 9 6.3335 9.74619 6.3335 10.6667C6.3335 11.5871 7.07969 12.3333 8.00016 12.3333Z"
                                stroke="#10140B"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M11.3335 14.6667H4.66683C2.00016 14.6667 1.3335 14.0001 1.3335 11.3334V10.0001C1.3335 7.33341 2.00016 6.66675 4.66683 6.66675H11.3335C14.0002 6.66675 14.6668 7.33341 14.6668 10.0001V11.3334C14.6668 14.0001 14.0002 14.6667 11.3335 14.6667Z"
                                stroke="#10140B"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                          </span>
                          <span>{t("Change Password")}</span>
                        </a>
                      </li>
                      {/* <li>
                        <a className="dropdown-item text-capitalize">
                          <span className="dropdown_item-icon">
                            <svg
                              width={20}
                              height={20}
                              viewBox="0 0 16 16"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10Z"
                                stroke="#10140B"
                                stroke-miterlimit="10"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M1.3335 8.58679V7.41345C1.3335 6.72012 1.90016 6.14679 2.60016 6.14679C3.80683 6.14679 4.30016 5.29345 3.6935 4.24679C3.34683 3.64679 3.5535 2.86679 4.16016 2.52012L5.3135 1.86012C5.84016 1.54679 6.52016 1.73345 6.8335 2.26012L6.90683 2.38679C7.50683 3.43345 8.4935 3.43345 9.10016 2.38679L9.1735 2.26012C9.48683 1.73345 10.1668 1.54679 10.6935 1.86012L11.8468 2.52012C12.4535 2.86679 12.6602 3.64679 12.3135 4.24679C11.7068 5.29345 12.2002 6.14679 13.4068 6.14679C14.1002 6.14679 14.6735 6.71345 14.6735 7.41345V8.58679C14.6735 9.28012 14.1068 9.85345 13.4068 9.85345C12.2002 9.85345 11.7068 10.7068 12.3135 11.7535C12.6602 12.3601 12.4535 13.1335 11.8468 13.4801L10.6935 14.1401C10.1668 14.4535 9.48683 14.2668 9.1735 13.7401L9.10016 13.6135C8.50016 12.5668 7.5135 12.5668 6.90683 13.6135L6.8335 13.7401C6.52016 14.2668 5.84016 14.4535 5.3135 14.1401L4.16016 13.4801C3.5535 13.1335 3.34683 12.3535 3.6935 11.7535C4.30016 10.7068 3.80683 9.85345 2.60016 9.85345C1.90016 9.85345 1.3335 9.28012 1.3335 8.58679Z"
                                stroke="#10140B"
                                stroke-miterlimit="10"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                          </span>
                          <span>{t("Setting")}</span>
                        </a>
                      </li> */}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
